export enum QueryKey {
    ADMIN = "admin",
    INTERVIEW_STATUS = "interviewStatus",
    INTERVIEWS = "interviews",
    USER = "user",
    USERS = "users",
    NOTIFICATIONS = "notifications",
}
